import { render, staticRenderFns } from "./FeedbackItems.vue?vue&type=template&id=23d7a9f1"
import script from "./FeedbackItems.vue?vue&type=script&lang=js"
export * from "./FeedbackItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23d7a9f1')) {
      api.createRecord('23d7a9f1', component.options)
    } else {
      api.reload('23d7a9f1', component.options)
    }
    module.hot.accept("./FeedbackItems.vue?vue&type=template&id=23d7a9f1", function () {
      api.rerender('23d7a9f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FeedbackItems.vue"
export default component.exports